import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DomainRecordsList as SchemaDomainRecordsList } from '../schemas/DomainRecordsList';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Возвращает список DNS-записей домена
 * @tags Domains
 * @summary Список записей домена
 */
export const ListDomainRecordsContentType = '' as const;
export type ListDomainRecordsRequest = void;
export type ListDomainRecordsResponses = LinkCommonErrorResponses & {
    /**
     * @description Список записей
     */
    '200': {
        'application/json': SchemaDomainRecordsList;
    };
};
export type ListDomainRecordsResponseSuccess = ListDomainRecordsResponses['200']['application/json'];
export type ListDomainRecordsSearchParams = undefined;
export type ListDomainRecordsPathParameters = undefined;
export const ListDomainRecordsUrl = '/domain/records' as const;
export const ListDomainRecordsMethod = 'GET' as const;
export const getListDomainRecordsUrl = (_params?: ListDomainRecordsPathParameters) => ListDomainRecordsUrl;
